import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Get Help - Recursos (español) Page
const ResourcesSpanishPage = () => {
  const recursos = [
    "Médico (Emergencia y Hospital)",
    "Médico (Atención Primaria)",
    "Salud Mental",
    "Dental",
    "Visión",
    "Legal (Inmigración)",
    "Legal (Otros Asuntos Civiles)",
    "SNAP (Alimentos para Niños Nacidos en EE. UU.)",
    "WIC (Alimentos para Mujeres, Bebés y Niños)",
    "Asistencia para Cuidado de Niños",
    "Clases de Inglés",
    "Medicaid de Emergencia (Alcance Limitado)",
    "Intervención Temprana Infantil",
    "Inscripción Escolar"
  ];

  return (
    <div data-testid="resources-spanish-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/xwp39obs_Resources.jpg"
        alt="Recursos Comunitarios"
      />

      {/* Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="resources-spanish-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Recursos
            </h1>
            
            <p className="text-[#666666] text-base md:text-lg leading-relaxed mb-10">
              Murphy's Giving Market puede ayudarle a buscar recursos comunitarios en las siguientes áreas. La disponibilidad y elegibilidad son determinadas por cada organización, y Murphy's Giving Market no puede garantizar servicios ni resultados.
            </p>
            
            <div className="space-y-3">
              {recursos.map((recurso, index) => (
                <motion.div
                  key={recurso}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  className="flex items-start gap-3"
                >
                  <div className="w-2 h-2 bg-[#C41E3A] rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-[#1A1A1A] text-base md:text-lg">{recurso}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ResourcesSpanishPage;
